import { useEffect, useState } from 'react';

const F = "'Inter',-apple-system,sans-serif";
const D = "'Bangers','Arial Black',cursive";
const PRISM_GRADIENT = 'linear-gradient(135deg,#F04E1A,#F5C842,#3B6FBF,#9B59B6,#16A34A)';

/**
 * Affiche une courte animation de déblocage de badge, centrée à l'écran,
 * puis disparaît toute seule. `badge` = { icon, label, tierName, color }.
 * Appelle `onDone` une fois l'animation terminée (pour enchaîner la suivante).
 */
export default function BadgeUnlockOverlay({ badge, onDone }) {
  const [phase, setPhase] = useState('in'); // in | hold | out

  useEffect(() => {
    const t1 = setTimeout(()=>setPhase('out'), 2600);
    const t2 = setTimeout(()=>onDone?.(), 3050);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [badge, onDone]);

  if (!badge) return null;
  const ringBg = badge.color === 'prismatic' ? PRISM_GRADIENT : (badge.color || 'var(--orange)');

  return (
    <div style={{
      position:'fixed', inset:0, zIndex:3000, display:'flex', alignItems:'center', justifyContent:'center',
      pointerEvents:'none', padding:'1.5rem',
    }}>
      <div style={{
        position:'absolute', inset:0, background:'rgba(28,22,18,.45)',
        opacity: phase==='out'?0:1, transition:'opacity .4s ease',
      }}/>
      <div style={{
        position:'relative', display:'flex', flexDirection:'column', alignItems:'center',
        animation: phase==='in' ? 'badgePopIn .6s cubic-bezier(.22,1.4,.4,1) forwards'
                 : phase==='out' ? 'badgePopOut .4s ease forwards' : 'none',
      }}>
        {/* Halo / rayons */}
        <div style={{
          position:'absolute', top:'50%', left:'50%', width:'280px', height:'280px',
          transform:'translate(-50%,-55%)', borderRadius:'50%',
          background: `radial-gradient(circle, ${badge.color==='prismatic'?'rgba(240,78,26,.35)':`${ringBg}55`} 0%, transparent 70%)`,
          animation:'badgeGlow 1.8s ease-in-out infinite',
        }}/>

        <div style={{
          width:'140px', height:'140px', borderRadius:'50%', padding:'6px',
          background: ringBg, boxShadow:'0 12px 36px rgba(0,0,0,.35)',
        }}>
          <div style={{width:'100%',height:'100%',borderRadius:'50%',background:'#FDFAF6',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'64px'}}>
            {badge.icon}
          </div>
        </div>

        <div style={{marginTop:'18px',fontFamily:F,fontSize:'11px',fontWeight:800,color:'#fff',textTransform:'uppercase',letterSpacing:'.1em',textShadow:'0 2px 8px rgba(0,0,0,.4)'}}>
          Badge débloqué
        </div>
        <div style={{fontFamily:D,fontSize:'1.6rem',letterSpacing:'.04em',color:'#fff',textShadow:'0 2px 10px rgba(0,0,0,.4)',marginTop:'2px',textAlign:'center'}}>
          {badge.label}{badge.tierName ? ` — ${badge.tierName}` : ''}
        </div>
      </div>

      <style>{`
        @keyframes badgePopIn {
          0%   { opacity:0; transform:scale(.3) rotate(-8deg); }
          60%  { opacity:1; transform:scale(1.08) rotate(2deg); }
          100% { opacity:1; transform:scale(1) rotate(0); }
        }
        @keyframes badgePopOut {
          from { opacity:1; transform:scale(1); }
          to   { opacity:0; transform:scale(.85) translateY(-10px); }
        }
        @keyframes badgeGlow {
          0%,100% { opacity:.7; transform:translate(-50%,-55%) scale(1); }
          50%     { opacity:1;  transform:translate(-50%,-55%) scale(1.12); }
        }
      `}</style>
    </div>
  );
}
